module.exports = __webpack_public_path__ + "static/media/optilume_ambassador_7.6b4623d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/optilume_ambassador_7.png
// module id = 682
// module chunks = 0